import store from '../store'
import axios from 'axios'
import { Base64 } from 'js-base64'
import { Installation } from 'config'

class HTTP {
  constructor () {
    this.state = store.getState().siteReducer
    store.subscribe(() => {
      this.state = store.getState().siteReducer
    })
  }
  get (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      params: {...query, ts: Date.now()},
      url: Installation.api_base + endpoint,
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      this.debug('GET', endpoint, query, options, res.data, true)
      return [null, res]
    }).catch(err => {
      this.debug('GET', endpoint, query, options, (err.response ? err.response.data : err), false )
      return [err, err.response ? err.response.data : err]
    })
  }
  make (endpoint, query, method, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      params: {...query, ts: Date.now()},
      url: Installation.api_base + endpoint,
      method: method,
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      this.debug('GET', endpoint, query, options, res.data, true)
      return [null, res]
    }).catch(err => {
      this.debug('GET', endpoint, query, options, (err.response ? err.response.data : err), false )
      return [err, err.response ? err.response : err]
    })
  }
  delete (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      data: query,
      url: Installation.api_base + endpoint + '?ts=' + Date.now(),
      method: 'delete',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      this.debug('DELETE', endpoint, query, options, res.data, true)
      return [null, res]
    }).catch(err => {
      this.debug('POST', endpoint, query, options, (err.response ? err.response.data : err), false )
      return [err, err.response ? err.response.data : err]
    })
  }
  ping (endpoint) {
    return axios.request({
      params: {ts: Date.now()},
      timeout: 4000,
      url: Installation.api_base + endpoint,
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(this.state.auth.username + ':' + this.state.auth.password)
      }
    }).then(res => {
      return [null, res]
    }).catch(err => {
      this.debug('POST', endpoint, query, options, (err.response ? err.response.data : err), false )
      return [err]
    })
  }
  post (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      data: query,
      url: Installation.api_base + endpoint + '?ts=' + Date.now(),
      method: 'post',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      this.debug('POST', endpoint, query, res.message, res, true)
      return [null, res]
    }).catch(err => {
      this.debug('POST', endpoint, query, options, (err.response ? err.response.data : err), false )
      return [err, err.response ? err.response.data : err]
    })
  }
  put (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      data: query,
      url: Installation.api_base + endpoint + '?ts=' + Date.now(),
      method: 'put',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      this.debug('PUT', endpoint, query, options, res.data, true)
      return [null, res]
    }).catch(err => {
      this.debug('POST', endpoint, query, options, (err.response ? err.response.data : err), false )
      return [err, err.response ? err.response.data : err]
    })
  }
  patch (endpoint, query, auth, options) {
    auth = auth || this.state.auth
    return axios.request({
      data: query,
      url: Installation.api_base + endpoint + '?ts=' + Date.now(),
      method: 'patch',
      headers: {
        'Cache-Control': 'no-cache',
        'Authorization': 'Basic ' + Base64.encode(auth.username + ':' + auth.password)
      },
      ...options
    }).then(res => {
      this.debug('PATCH', endpoint, query, options, res.data, true)
      return [null, res]
    }).catch(err => {
      this.debug('POST', endpoint, query, options, (err.response ? err.response.data : err), false )
      return [err, err.response ? err.response.data : err]
    })
  }
  debug (method, endpoint, query, message, response, success) {
    if (!process.env.REACT_APP_DEBUG_ENABLED) return
    console.log('%cFiring request: ' + endpoint, 'background: #222; color: #bada55')
    console.log('%cSuccess: ' + (success ? 'TRUE' : 'FALSE'), (success ? 'color: #2ecc71' : 'color: #e74c3c'))
    console.log('Method: ', method)
    console.log('Query: ', (query === undefined ? {} : query))
    console.log('Response: ', response)
    console.log('')
  }
}
export default new HTTP()



// WEBPACK FOOTER //
// ./src/API/http.js